// extracted by mini-css-extract-plugin
export default {"infoTextResize":"infoTextResize___2NuSa","item":"item____npCc","figure":"figure___3QVAq","text":"text___28meT"};